import axiosInstance from 'api/axiosInstance';
import type { BoundingBoxOCR } from 'types/ai.types';

const getDocumentBoundingBoxes = (
  documentId: string,
): Promise<BoundingBoxOCR[]> =>
  axiosInstance.get(
    `/v2/repository-documents/${documentId}/fields/bounding-boxes`,
  );

export default getDocumentBoundingBoxes;
